import { Job, Lead, Expense, Drone, DroneMission, Activity, Contact, FinancialRecord, TimeEntry, ContractorInvoice, LedgerEntry, MissionTemplate, FlightLog, MissionReport, NotificationItem } from './types';

export interface DataState {
  leads: Lead[];
  jobs: Job[];
  expenses: Expense[];
  drones: Drone[];
  missions: DroneMission[];
  missionTemplates: MissionTemplate[];
  flightLogs: FlightLog[];
  missionReports: MissionReport[];
  activities: Activity[];
  contacts: Contact[];
  financialRecords: FinancialRecord[];
  timeEntries: TimeEntry[];
  contractorInvoices: ContractorInvoice[];
  ledgerEntries: LedgerEntry[];
  notifications: NotificationItem[];
  activeToasts: NotificationItem[];
  arborlinkJobs: any[];
}

export const initialDataState: DataState = {
  leads: [],
  jobs: [],
  expenses: [],
  drones: [],
  missions: [],
  missionTemplates: [],
  flightLogs: [],
  missionReports: [],
  activities: [],
  contacts: [],
  financialRecords: [],
  timeEntries: [],
  contractorInvoices: [],
  ledgerEntries: [],
  notifications: [],
  activeToasts: [],
  arborlinkJobs: [],
};

export type DataAction =
  | { type: 'SET_LEADS'; payload: Lead[] }
  | { type: 'SET_JOBS'; payload: Job[] }
  | { type: 'SET_EXPENSES'; payload: Expense[] }
  | { type: 'SET_DRONES'; payload: Drone[] }
  | { type: 'SET_MISSIONS'; payload: DroneMission[] }
  | { type: 'SET_MISSION_TEMPLATES'; payload: MissionTemplate[] }
  | { type: 'SET_FLIGHT_LOGS'; payload: FlightLog[] }
  | { type: 'SET_MISSION_REPORTS'; payload: MissionReport[] }
  | { type: 'SET_ACTIVITIES'; payload: Activity[] }
  | { type: 'SET_CONTACTS'; payload: Contact[] }
  | { type: 'SET_FINANCIAL_RECORDS'; payload: FinancialRecord[] }
  | { type: 'SET_TIME_ENTRIES'; payload: TimeEntry[] }
  | { type: 'SET_CONTRACTOR_INVOICES'; payload: ContractorInvoice[] }
  | { type: 'SET_LEDGER_ENTRIES'; payload: LedgerEntry[] }
  | { type: 'SET_NOTIFICATIONS'; payload: NotificationItem[] }
  | { type: 'SET_ACTIVE_TOASTS'; payload: NotificationItem[] }
  | { type: 'SET_ARBORLINK_JOBS'; payload: any[] }
  | { type: 'ADD_NOTIFICATION'; payload: NotificationItem }
  | { type: 'ADD_TOAST'; payload: NotificationItem }
  | { type: 'REMOVE_TOAST'; payload: string }
  | { type: 'ADD_ACTIVITY'; payload: Activity }
  | { type: 'MARK_NOTIFICATION_READ'; payload: string }
  | { type: 'CLEAR_NOTIFICATIONS' }
  | { type: 'BULK_SET'; payload: Partial<DataState> };

export function dataReducer(state: DataState, action: DataAction): DataState {
  switch (action.type) {
    case 'SET_LEADS':
      return { ...state, leads: action.payload };
    case 'SET_JOBS':
      return { ...state, jobs: action.payload };
    case 'SET_EXPENSES':
      return { ...state, expenses: action.payload };
    case 'SET_DRONES':
      return { ...state, drones: action.payload };
    case 'SET_MISSIONS':
      return { ...state, missions: action.payload };
    case 'SET_MISSION_TEMPLATES':
      return { ...state, missionTemplates: action.payload };
    case 'SET_FLIGHT_LOGS':
      return { ...state, flightLogs: action.payload };
    case 'SET_MISSION_REPORTS':
      return { ...state, missionReports: action.payload };
    case 'SET_ACTIVITIES':
      return { ...state, activities: action.payload };
    case 'SET_CONTACTS':
      return { ...state, contacts: action.payload };
    case 'SET_FINANCIAL_RECORDS':
      return { ...state, financialRecords: action.payload };
    case 'SET_TIME_ENTRIES':
      return { ...state, timeEntries: action.payload };
    case 'SET_CONTRACTOR_INVOICES':
      return { ...state, contractorInvoices: action.payload };
    case 'SET_LEDGER_ENTRIES':
      return { ...state, ledgerEntries: action.payload };
    case 'SET_NOTIFICATIONS':
      return { ...state, notifications: action.payload };
    case 'SET_ACTIVE_TOASTS':
      return { ...state, activeToasts: action.payload };
    case 'SET_ARBORLINK_JOBS':
      return { ...state, arborlinkJobs: action.payload };
    case 'ADD_NOTIFICATION':
      return { ...state, notifications: [action.payload, ...state.notifications] };
    case 'ADD_TOAST':
      return { ...state, activeToasts: [action.payload, ...state.activeToasts] };
    case 'REMOVE_TOAST':
      return { ...state, activeToasts: state.activeToasts.filter(t => t.id !== action.payload) };
    case 'ADD_ACTIVITY':
      return { ...state, activities: [action.payload, ...state.activities].slice(0, 50) };
    case 'MARK_NOTIFICATION_READ':
      return {
        ...state,
        notifications: state.notifications.map(n => n.id === action.payload ? { ...n, read: true } : n),
      };
    case 'CLEAR_NOTIFICATIONS':
      return { ...state, notifications: [] };
    case 'BULK_SET':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
